<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Stock Total</h1>
		<div class="content-wrapper">
			<!-- <b-field label="Select Shop (Required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field> -->

			<b-field label="Select Brand (required)">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="radioCheck">
				<b-radio v-model="type" name="name" native-value="sales">Sales</b-radio>
				<b-radio v-model="type" name="name" native-value="stock">Stock</b-radio>
			</div>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">EXPORT</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { bdBrands } from '@/data/brands.js'

export default {
	name: 'Dashboard',
	data: () => ({
		isLoading: false,
		totalSales: [],
		startingDate: null,
		endingDate: null,
		minDate: null,
		maxDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		brands: [], // To store brands
		selectedBrand: null,
		brandSuggestions: '',
		type: 'sales'
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		await this.getBrands()
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				console.log(apiGetBrands.data)

				this.brands = apiGetBrands.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (!this.selectedBrand) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Brand is required'
				})

				return
			}

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			var data = {}

			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				brand: this.selectedBrand._id,
				time: {
					createdAt
				}
			}

			const salesExport = await this.$api.salesExport({ data })

			if (salesExport && salesExport.data) {
				let results = salesExport.data

				let headers = ['BD CODE', 'BARCODE', 'NAME', 'BRAND NAME', 'BRAND CODE', 'SELLING PRICE']

				for (const shop of this.shops) {
					headers.push(shop.shop_id)
				}

				let csv = headers.join(',')

				csv += '\r\n'

				console.log(csv)

				for (const result in results) {
					const info = results[result].info
					let toAdd = [result]

					// barcode
					toAdd.push(info.barcode)
					// name
					toAdd.push(info.name)
					// brand name
					toAdd.push(this.selectedBrand.name)
					// brand code
					toAdd.push(this.selectedBrand.code)
					// selling price
					toAdd.push(info.price)

					for (const shop of this.shops) {
						let found = false
						for (const edata in results[result]) {
							if (shop.shop_id == edata) {
								found = true
								toAdd.push(results[result][edata])
							}
						}

						if (!found) {
							toAdd.push('')
						}
					}
					let row = toAdd.join(',')

					csv += row + '\r\n'
				}

				var csvData = new Blob([csv], { type: 'text/csv' }) //new way
				var csvUrl = URL.createObjectURL(csvData)

				var link = document.createElement('a')
				link.setAttribute('href', csvUrl)
				link.setAttribute('download', this.selectedBrand.code + '_export_stock.csv')
				document.body.appendChild(link) // Required for FF

				link.click()
				link.remove()
			}

			this.isLoading = false
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
